import { WbTrapFocus } from './WbTrapFocus';

export class WbSearchOverlay {
  constructor() {
    this.init();
  }

  init() {
    this.setProperties();
    this.bindListeners();
    this.WbTrapFocus = new WbTrapFocus({ ele: this.overlay, activeClass: 'wb-overlay--open' });
  }

  setProperties() {
    this.overlay = document.querySelector('#wb-search-overlay');
    this.searchInput = document.querySelector('#wb-search');
    this.searchTriggers = document.querySelectorAll('.wb-search-overlay__trigger');
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-search-overlay__trigger',
        _this.openSearch.bind(_this)
      );

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-search-overlay__close', _this.closeSearch.bind(_this));

    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
    document.addEventListener('_page_loaded', _this.updateProperties.bind(_this));
  }

  updateProperties() {
    this.overlay = document.querySelector('#wb-search-overlay');
    this.searchInput = document.querySelector('#wb-search');
    this.searchTriggers = document.querySelectorAll('.wb-search-overlay__trigger');
  }

  openSearch(e) {
    this.refTrigger = e.targetElement;
    this.searchTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });
    this.overlay._show(0.5);
    this.overlay.classList.add('wb-overlay--open');
    this.searchInput.select();
    document.querySelector('html, body').classList.add('wb-overlay--active');
  }

  closeSearch() {
    this.searchTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.overlay._hide(0.5).then(() => this.overlay.classList.remove('wb-overlay--open'));
    this.refTrigger.focus();
    this.refTrigger = false;
    document.querySelector('html, body').classList.remove('wb-overlay--active');
  }

  keydownEventListener(e) {
    const _this = this;
    let isOpen = this.overlay.classList.contains('wb-overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        _this.closeSearch();
        break;
    }
  }
}
